// event.preventDefault();
// try {
//   let selectedKeys = options.map(({ key }) => key).filter(key => stateMap[key]);
//   if (lastOptionIsNone && selectedKeys.length === 0) throw new Error('Geen antwoord geselecteerd.');
//   if (lastOptionIsFreeText && stateMap[freeTextOptionKey]) {
//     if (!freeText) throw new Error('Vul een waarde in bij de vrije optie, of vink deze uit.');
//     selectedKeys = selectedKeys.filter(key => key !== freeTextOptionKey);
//     selectedKeys.push(`${freeTextOptionKey}:${freeText}`);
//   }
//   onAnswer(validateAnswer(question, selectedKeys));
// } catch (err) {
//   setError(err.message);
// }

export default (question, answer, language = 'nl') => {
  const { options, minSelect, maxSelect, lastOptionIsFreeText, lastOptionIsNone } = question;
  if (lastOptionIsNone && answer.length === 0) throw new Error('Geen antwoord geselecteerd.');

  const optionKeys = options.map(option => option.key);
  const noneOptionKey = lastOptionIsNone ? optionKeys[optionKeys.length - 1] : null;
  const freeTextOptionKey = lastOptionIsFreeText ? options[options.length - 1].key : null;
  let answers = 0;
  for (const [key, chosenOption] of Object.entries(answer)) {
    if (!key || key === 'null') {
      continue;
    }
    const isFreeTextOption = lastOptionIsFreeText && key.startsWith(`${freeTextOptionKey}:`);
    if (isFreeTextOption && key === `${freeTextOptionKey}:`) {
      throw new Error(
          language === 'nl'
              ? 'Vul een waarde in bij de vrije optie, of vink deze uit.'
              : 'Please enter a value for the open option, or deselect it.'
      );
    }
    if (!optionKeys.includes(key) && !isFreeTextOption) {
      throw new Error(language === 'nl' ? 'Onbekende antwoord(en) gekozen.' : 'Unknown answer(s) picked.');
    }
    if (key === noneOptionKey && answer.length > 1)
      throw new Error(language === 'nl' ? 'Ongeldige combinatie.' : 'Invalid combination.');
    if (chosenOption){
      answers++;
    }
  }
  if (minSelect && answers < minSelect) {
    throw new Error(
      language === 'nl'
        ? `Selecteer minimaal ${minSelect} ${minSelect === 1 ? 'antwoord' : 'antwoorden'}.`
        : `Please select at least ${minSelect} ${minSelect === 1 ? 'answer' : 'answers'}.`
    );
  } else if (maxSelect && answers > maxSelect) {
    throw new Error(
      language === 'nl'
        ? `Selecteer maximaal ${maxSelect} ${maxSelect === 1 ? 'antwoord' : 'antwoorden'}.`
        : `Please select at most ${maxSelect} ${maxSelect === 1 ? 'answer' : 'answers'}.`
    );
  }

  if (answers === 1 && answer[0] === noneOptionKey) return [];

  return answer;
};
